import styled, { css } from 'styled-components';
import addAlpha from 'utils/addAlpha';
import DefaultSpinner from 'components/Spinner';
import AddImageIcon from 'assets/icons/add-image.svg?react';
import ImageIcon from 'assets/icons/image.svg?react';
import { Overline, Caption, Small, H4 } from 'components/Typography';
import { FiEye, FiAlertCircle } from 'react-icons/fi';
import { LabelProps } from './types';

// TODO: TFR-44 move to container group
export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

// TODO: TFR-44 move to container group
export const InputContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.navyGreenLight};
  border: 0.0625rem solid ${({ theme }) => theme.colors.white};
  border-radius: 0.75rem;
  width: 100%;
  display: flex;
  align-items: center;
  overflow: hidden;
  justify-content: space-between;
  padding: 1rem 0.875rem;
  transition: 0.3s;

  &:focus-within {
    border: 1px solid ${({ theme }) => theme.colors.gray3};
  }
  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.gray3};
  }
`;

// TODO: TFR-49 make separate component. Probably - form helpers etc. This is not unique for input. It could be reused in other form sections
export const Component = styled.input`
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.8)};
  background-color: inherit;
  border-radius: 0.25rem;
  border: none;
  font-size: 1rem;
  outline: 0;
  line-height: 1.375rem;
  width: 100%;
  ::placeholder {
    color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.4)};
  }
  :disabled {
    color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.2)};
    ::placeholder {
      color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.2)};
    }
  }
`;

// TODO: TFR-49 make separate component. Probably - form helpers etc. This is not unique for input. It could be reused in other form sections
export const ComponentTextArea = styled.textarea`
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.8)};
  background-color: inherit;
  border-radius: 0.25rem;
  border: none;
  font-family:
    'Gilroy',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    'Roboto',
    'Oxygen',
    'Ubuntu',
    'Cantarell',
    'Fira Sans',
    'Droid Sans',
    'Helvetica Neue',
    sans-serif;
  font-size: 1rem;
  outline: 0;
  line-height: 1.375rem;
  width: 100%;
  height: 8.5rem;
  ::placeholder {
    color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.4)};
  }
  :disabled {
    color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.2)};
    ::placeholder {
      color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.2)};
    }
  }
`;

// TODO: TFR-45:Label make unique name or do not export
export const Label = styled(Overline)<LabelProps>`
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
  font-weight: 600;
  letter-spacing: 0.1em;
  margin-bottom: 0.75rem;
  ${({ $disabled }) =>
    $disabled &&
    css`
      color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.2)};
    `}
`;

// TODO: TFR-49 make separate component. Probably - form helpers etc. This is not unique for input. It could be reused in other form sections
export const IconError = styled(FiAlertCircle)`
  color: ${({ theme }) => theme.colors.redMedium};
  height: 1rem;
  width: 1rem;
  margin-left: 0.5rem;
`;

// TODO: TFR-49 make separate component. Probably - form helpers etc. This is not unique for input. It could be reused in other form sections
export const Error = styled(Caption)`
  color: ${({ theme }) => theme.colors.redMedium};
  margin-top: 0.5rem;
`;

export const IconVisability = styled(FiEye)`
  color: ${({ theme }) => theme.colors.gray4};
  height: 1rem;
  width: 1rem;
  margin-left: 0.5rem;
`;

export const ComponentFile = styled.input`
  display: none;
`;

type ImageContainerProps = {
  disabled: boolean | undefined;
};

export const ImageContainer = styled.div`
  width: 25rem;
  height: 25rem;
  position: relative;
  cursor: ${(props: ImageContainerProps) =>
    props.disabled ? 'default' : 'pointer'};
  user-select: none;
`;

export const ImagePreview = styled.img`
  width: 25rem;
  height: 25rem;
  overflow: hidden;
  border-radius: 16px;
`;

export const PlaceholderContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.greenExtraLight};
  border-radius: 16px;
`;

export const AddImage = styled(AddImageIcon)`
  color: ${({ theme }) => theme.colors.freshGreen};
  width: 4.5rem;
  margin-bottom: 1rem;
`;
export const Image = styled(ImageIcon)`
  color: ${({ theme }) => theme.colors.freshGreen};
  width: 4.5rem;
  margin-bottom: 1rem;
`;
export const DragNDropText = styled(H4)`
  color: ${({ theme }) => theme.colors.darkGreen};
`;
export const FormatHint = styled(Small)`
  color: ${({ theme }) => theme.colors.greenMedium};
  font-size: 1rem;
`;

type LoaderOverlayProps = {
  isLoading: boolean;
};

export const LoaderOverlay = styled.div<LoaderOverlayProps>`
  border-radius: 16px;
  opacity: 0.75;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: ${({ theme }) => theme.colors.white};
  display: ${({ isLoading }) => (isLoading ? 'flex' : 'none')};
  flex-direction: column;
  justify-content: center;
  align-items: center;

  div:hover > & {
    display: flex;
  }
`;

export const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 15rem;
`;

export const LoaderText = styled(Caption)`
  color: ${({ theme }) => theme.colors.darkGreen};
  font-size: 1.2rem;
  margin-top: 0.5rem;
  font-weight: 600;
  align-self: center;
`;

export const Spinner = styled(DefaultSpinner)`
  color: ${({ theme }) => theme.colors.darkGreen};
  width: 2rem;
  align-self: center;
`;
